import { Box, Button, styled } from '@mui/material'
import { acceptedFileTypes } from '../../config'

const Input = styled('input')({
  display: 'none',
})

const FileSelector = ({ onSubmitForm, onSelectFileChange }) => (
  <form onSubmit={onSubmitForm} method="post" encType="multipart/form-data">
    <label>
      <Input
        accept={acceptedFileTypes}
        type="file"
        name="zipFile"
        onChange={onSelectFileChange}
        multiple={true}
      />
      <Box m={3}>
        <Button variant="contained" color="secondary" component="span">
          Select file...
        </Button>
      </Box>
    </label>
  </form>
)

export default FileSelector
